import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Header from "./Header/Header";
import BookingHome from "./Container/Home/BookingHome";
import BookingForm from "./Container/BookingForm";
import LoginModal from "./Modals/LoginModal";
import { useSelector } from "react-redux";
import ResetPWModal from "./Modals/ResetPwModal";
import ProtectedRoute from "./ProtectedRoute";
import InfoModal from "./About/InfoModal";
import BookingHistory from "./BookingHistory/BookingHistory";
import SearchBooking from "./SearchBooking/SearchBooking";

const BookSlotComponent = lazy(() => import("./Container/BookSlotComponent"));

function App() {
  const { showProductInfo } = useSelector((state) => state.userInfoSlice);

  const isAuthenticated = !!window?.localStorage?.getItem("token");

  return (
    <Router>
      <div className="App">
        <Header />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/reset-password/:token" element={<ResetPWModal />} />
            <Route
              path="/login"
              element={
                isAuthenticated ? (
                  <Navigate to="/home" replace />
                ) : (
                  <LoginModal />
                )
              }
            />
            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <Navigate to="/home" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="" element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace /> } />
            <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />} >
              <Route path="/home" element={<BookingHome />} />
              <Route path="/booking-form" element={<BookingForm />} />
              <Route path="/book-slot" element={<BookSlotComponent />} />
              <Route path="/my-booking-history" element={<BookingHistory />} />
              <Route path="/search-booking" element={<SearchBooking />} />
            </Route>
          </Routes>
        </Suspense>
        {showProductInfo && <InfoModal />}
      </div>
    </Router>
  );
}

export default App;
